import Button from './Button.container';
import { className } from './Button';
import { IButtonProps as IButton } from './Button.interface';

export default Button;
export { Button, IButton, className };
